var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-shopping-cart"},[_c('base-bread-crumb',{attrs:{"items":_vm.breadCrumbsItems}}),_c('h1',{staticClass:"main-title mb-25"},[_vm._v("Shopping Cart")]),_c('div',{staticClass:"contentBox"},[_vm._m(0),_c('p',[_vm._v("Your cart is empty.")]),_c('p',[_vm._v("Keep shopping to find a service!")]),_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":{
				name: 'Shop',
				params: {
					lang: _vm.$i18n.locale,
					page: '1'
				},
			}}},[_vm._v(" Keep Shopping ")])],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image"},[_c('img',{staticClass:"img-fluid",attrs:{"src":require("../assets/images/file.png")}})])}]

export { render, staticRenderFns }